export default '/static/frontend/ReachDigital/12gobiking/dist/assets/klarna-pay-later-en-141ce5c9.svg'